import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type AppState, type EntityRef, Status } from "@client/types";
import { preload as preloadSlider } from "@common/controls/Inputs/Slider/component";
import { type Dispatch } from "react";
import { initAction } from "../actions";
import api from "./api";
import { getIdsSelector, localStateSelector } from "./selectors";
import { type PackagePricing } from "./types";

export enum Actions {
  InitBegin = "MODULE_PACKAGE_PRICING_INIT_BEGIN",
  InitFailure = "MODULE_PACKAGE_PRICING_INIT_FAILURE",
  InitSuccess = "MODULE_PACKAGE_PRICING_INIT_SUCCESS"
}

export type InitBeginActionData = EntityRef & PackagePricing.Ids;
export type InitSuccessActionData = PackagePricing.Api.InitResponse;
const _initAsync = initAction<AppState, InitBeginActionData, PackagePricing.Api.InitResponse, InitSuccessActionData>({
  types: {
    begin: Actions.InitBegin,
    failure: Actions.InitFailure,
    success: Actions.InitSuccess
  },
  action: (state: AppState, dispatch: any, args: InitBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);
    return api.init(apiInfo, args);
  }
});

export const init = (ref: EntityRef) => (dispatch: Dispatch<any>, getState: () => AppState) => {
  const state = getState();
  const localState = localStateSelector(state, ref);

  if (localState.status === Status.None) {
    preloadSlider();
  }

  const idsSelector = getIdsSelector();
  dispatch(
    _initAsync({
      ...ref,
      ...idsSelector(state, ref)
    })
  );
};
